<template>
  <div class="fixed-bar" id="fixed-bar">
    <div
      class="recycle-one-stop-wrap"
      v-if="hasActiveOneStopAc && !isFullPayBuy"
      v-track="[
        {
          act: 'show',
          params: {
            cfrom: '081|080|02|077',
            event_id: '081|080|02|077',
            source_type: supplierId,
            sku_id: skuId
          }
        },
        {
          act: 'click',
          params: {
            cfrom: '|081|081|01|077',
            event_id: '|081|081|01|077',
            source_type: supplierId,
            sku_id: skuId
          }
        }
      ]"
      @click="goToRenew"
    >
      <RecycleOneStop :oneStopAct="oneStopAct" />
    </div>
    <!--快速参团模块-->
    <quick-groupon v-if="discountType == 'group' && !isLottery" @submit="submit"></quick-groupon>
    <div class="tips" v-if="ordered && (extCode == 2 || extCode == 3)">
      <p>
        {{ orderedTips }}
      </p>
    </div>
    <div
      class="tips"
      :class="{
        'tips-vip': isVipFirstBuy && commodityVipFirst,
        'tips-vip-allow': isVipFirstBuy && commodityVipFirst && commodityVipFirst.vipAllowed,
        'tips-vip-notallow': isVipFirstBuy && commodityVipFirst && !commodityVipFirst.vipAllowed
      }"
      v-else-if="floatTips"
      tabindex="0"
    >
      <p v-if="isSpot && commodityDeposite && commodityDeposite.spotDepositDesc && commodityDeposite.state != 2">
        {{ commodityDeposite.spotDepositDesc }}
      </p>
      <p v-else>
        {{ floatTips }}
      </p>
      <div
        class="vip-upgrade"
        v-if="
          !env.isPadVivoApp &&
          isVipFirstBuy &&
          commodityVipFirst &&
          !commodityVipFirst.vipAllowed &&
          commodityVipFirst.upLevelUrl
        "
        @click="goUpgrade"
      >
        升级会员
        <v-icon class="icon-right" name="arrow-right" />
      </div>
    </div>
    <div class="action">
      <div class="links">
        <div class="link_item" v-if="!env.isVivoApp" @click="goHome" role="button" tabindex="0">
          <em class="icon icon--home"></em>
          <i class="text">首页</i>
        </div>
        <div class="link_item" @click="toConnect" role="button" tabindex="0">
          <span class="icon icon--concat">
            <i class="message" v-if="customerService"></i>
          </span>
          <i class="text">客服</i>
        </div>
        <div class="link_item" v-if="isShowCollect" role="button" tabindex="0" @click="toggleCollected">
          <span
            class="icon icon--collection"
            :class="{
              'icon--collected': collected,
              'icon--clicked': isClicked
            }"
          ></span>
          <i class="text">收藏</i>
        </div>
        <div
          class="link_item"
          v-if="!isGroup && !isVipFirstBuy && !isPreHot & !isMoYin"
          @click="jumpTo()"
          role="button"
          :aria-label="cartAriaLabel"
          tabindex="0"
        >
          <span class="icon icon--shopcart">
            <span class="badge vos-tabnum-show" v-if="cartNumber > 0">
              <i class="num">{{ cartNumber }}</i>
            </span>
          </span>
          <i class="text">购物车</i>
        </div>
      </div>
      <!-- 拼团活动单独处理 -->
      <div class="btns" v-if="isGroup">
        <div class="btn-action btn-action--dark" v-if="!extCode && !isLottery" @click="ordinaryBuy" tabindex="0">
          <span class="text text--main">￥{{ skuInfo.commoditySkuBaseInfo.salePrice }}</span>
          <span class="text text--sub">单独购买</span>
        </div>
        <div class="btn-action btn-action--group confirm" @click="group" tabindex="0">
          <span class="text text--main">￥{{ skuInfo.commoditySkuDiscount.commodityDiscountPrice }}</span>
          <span class="text text--sub">一键开团</span>
        </div>
      </div>
      <!-- 定金预售和全款预定活动倒计时 -->
      <!-- 会员先享购活动倒计时 -->
      <div class="btns" v-else-if="isPreHot" tabindex="0">
        <div
          class="btn-action confirm"
          :class="{
            'btn-action--depositcountdown': isDepositBuy || isFullPayBuy,
            'btn-action--vipcountdown': isVipFirstBuy
          }"
          @click="confirm"
        >
          <span class="text">距开始</span>
          <v-count-down
            class="text"
            ref="count"
            :current="currentTime"
            :start="startTime"
            :end="ednTime"
            :startFun="refresh"
            :endFun="endFun"
          ></v-count-down>
        </div>
      </div>
      <!-- 常规按钮 -->
      <div class="btns" v-else>
        <div
          class="btn-action btn-action--dark cart"
          v-if="hasShopCart"
          @click="addCart"
          id="add-cart"
          role="button"
          tabindex="0"
        >
          <span class="text">加入购物车</span>
        </div>
        <div
          class="btn-action btn-action--dark btn-action--margin spot"
          v-if="isSpot"
          @click="spotBuy"
          role="button"
          tabindex="0"
        >
          <span class="text text--main">现货购买</span>
          <span class="text text--sub">￥{{ isBlur ? '----' : spotPrice }}</span>
        </div>
        <div
          class="btn-action confirm"
          :class="{
            'btn-action--darkgolden': discountType == 'vip' && !isGray,
            'btn-action--graygolden': discountType == 'vip' && isGray,
            'btn-action--gray': isGray,
            'btn-action--margin': btnSubText,
            'btn-action--purple': discountType == 'fullpay' || discountType == 'deposit',
            'btn-action--light-red': isLightRed
          }"
          @click="confirm"
          role="button"
          tabindex="0"
        >
          <span class="text" v-if="isVipFirstBuy && vipFirstBuyDisable">当前商品已抢光</span>
          <template v-else>
            <span class="text text--main">{{ btnMainText }}</span>
            <span class="text text--sub" v-if="btnSubText">{{ btnSubText }}</span>
          </template>
          <div class="f-price" v-if="isSpot && commodityEstimated && commodityEstimated.commodityEstimatedPrice">
            <span class="p-left"></span>
            <span class="p-center">到手￥{{ isBlur ? '----' : commodityEstimated.commodityEstimatedPrice }}</span>
            <span class="p-right"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { vipFirstBuyPopup } from '@/components'
import QuickGroupon from '../quick-groupon'
import config from '@/config'
import { formatNumber } from 'utils/common'
import env from '@/utils/clientEnv'
import { app } from '@/utils'
// api
import { collectionProduct } from '../../index/api'
import shareRewardTip from './utils/shareRewardTip.js'
import RecycleOneStop from './components/recycle-one-stop'

export default {
  name: 'FixedBar',
  props: {
    commonTrackData: {
      type: Object,
      default() {
        return {}
      }
    },
    ordered: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  components: {
    QuickGroupon,
    RecycleOneStop
  },
  data() {
    return {
      // 是否有客服消息
      customerService: 0,
      shopUrl: config.path.shopUrl,
      env: env,
      // 是否点击收藏成功
      isClicked: false,
      // 防重点
      isDoing: false,
      timeId: null
    }
  },
  computed: {
    ...mapState('detailv3', [
      'skuId',
      'spuId',
      'spuInfo',
      'skuInfo',
      'skuSelectParams',
      'cartNumber',
      'collectedSkuIds',
      'spotEstimatedPrice',
      'vipFirstBuyDisable',
      'isRegulate',
      'isShowRemarkPopup'
    ]),
    ...mapGetters('detailv3', [
      'goodsType',
      'isGift', // 仅作赠品
      'isGroup', // 拼团
      'isVipFirstBuy', // 是否会员先享购
      'commodityVipFirst', // 会员先享购信息
      'isDepositBuy', //是否为定金预售
      'commodityDeposite', //定金预售信息
      'isFullPayBuy', //是否为全款预定
      'commodityFullPay', //全款预定信息
      'isLottery', // 一分团
      'isSimpleGroup', // 简单拼团（无服务，且只有1个sku）
      'skuNum',
      'hasRecommend',
      'discountType',
      'extCode',
      'isSeeOther',
      'commodityEstimated',
      'floatTips',
      'appointId',
      'isServiceGoods',
      'isPreHot',
      'isSpot',
      'currentSuiteInfo',
      'isMoYin',
      'hasAdditionCommodity', // 是否有加购商品
      'totalAdditionCommodityActivityPrice', // 加购商品总售价
      'hasActiveOneStopAc' // 是否露出悬浮条以旧换新活动
    ]),
    // 获取skuid
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuId
    },
    isBlur() {
      return !this.isRegulate
    },
    // 购物车无障碍阅读内容
    cartAriaLabel() {
      let label = '购物车'
      if (this.cartNumber && this.cartNumber > 0) {
        label = `购物车，有${this.cartNumber}个商品`
      }
      return label
    },
    // 是否已经收藏
    collected() {
      return this.collectedSkuIds.indexOf(this.skuId) > -1
    },
    //是否展示收藏(拼团，赠品，会员先享购以及倒计时不显示)，952开始非app不显示收藏按钮
    isShowCollect() {
      return !this.isGroup && !this.giftSign && !this.isVipFirstBuy && !this.isPreHot && env.isVivoApp
    },
    // 定金预售现货购买价格
    spotPrice() {
      // 优先展示套餐价
      if (this.currentSuiteInfo.id) {
        return this.currentSuiteInfo.totalPrice
      } else {
        // 到手价
        if (this.spotEstimatedPrice?.commodityEstimatedPrice) {
          return this.spotEstimatedPrice?.commodityEstimatedPrice
        }
        return this.skuInfo.commoditySkuBaseInfo.salePrice
      }
    },
    //当前时间
    currentTime() {
      return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.currentTime)
    },
    //开始时间
    startTime() {
      if (this.isVipFirstBuy) {
        //会员先享购
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.startTime)
      } else if (this.isDepositBuy) {
        //定金预售
        return parseInt(
          this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositStartTime
        )
      } else if (this.isFullPayBuy) {
        //全款预定
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityFullPay?.startTime)
      } else {
        return 0
      }
    },
    //结束时间
    ednTime() {
      if (this.isVipFirstBuy) {
        //会员先享购
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.endTime)
      } else if (this.isDepositBuy) {
        //定金预售
        return parseInt(
          this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositEndTime
        )
      } else if (this.isFullPayBuy) {
        //全款预定
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityFullPay?.endTime)
      } else {
        return 0
      }
    },
    //是否显示倒计时
    // isCountDown() {
    //   if ((this.isVipFirstBuy || this.isDepositBuy || this.isFullPayBuy) && this.currentTime < this.startTime) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    // 是否是赠品
    giftSign() {
      return this.spuInfo?.commoditySpu?.giftSign == 1
    },
    // 是否是服务类商品，如果是服务类商品，则直接下单，不调起弹层
    isService() {
      return this.goodsType == 3
    },
    // 是否展示购物车
    hasShopCart() {
      return this.goodsType != 3 && this.skuInfo?.commoditySkuButton?.addShopCart == 1
    },
    // 按钮是否置灰，当下架或缺货且没有推荐时需要置灰，会员先享购预热期间置灰
    isGray() {
      return (
        ((this.isGift || this.extCode == 1 || this.extCode == 4) && !this.hasRecommend) ||
        (this.isVipFirstBuy && this.commodityVipFirst?.vipAllowed && this.commodityVipFirst?.state == 2) ||
        (this.isVipFirstBuy && this.vipFirstBuyDisable)
      )
    },
    isLightRed() {
      return this.ordered && this.appointId
    },
    // 按钮主文案
    btnMainText() {
      if (this.isSeeOther) {
        return '查看推荐商品'
      } else if (this.isGift) {
        return '仅作为赠品'
      } else if (this.skuInfo?.commoditySkuButton?.commodityMainButtonCode == 1 && !this.commodityEstimated) {
        return '立即购买'
      } else if (this.extCode == 2) {
        return this.ordered ? '已预约' : '立即预约'
      } else if (this.extCode == 3) {
        return this.ordered ? '已登记' : '到货通知'
      } else if (this.isSpot) {
        return this.skuInfo?.commoditySkuButton?.commodityMainButtonDesc.split('¥')[0]
      }else if (this.isMoYin) {
        const buttonCode = this.skuInfo?.commoditySkuButton?.commodityMainButtonCode
        return buttonCode==1?'领券定制':'立即定制'
      }
      return this.skuInfo?.commoditySkuButton?.commodityMainButtonDesc
    },
    // 按钮副文案
    btnSubText() {
      // 仅为赠品或下架，预约，无库存状态没有副文案
      if (this.isGift || this.extCode) {
        return ''
      }
      if (this.isDepositBuy) {
        if (this.isSpot) {
          return '￥' + (this.isBlur ? '--' : this.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice)
        }
      } else {
        if (this.commodityEstimated) {
          let text = this.skuInfo?.commoditySkuButton?.commodityAssistantButtonDesc
          let price = this.commodityEstimated?.commodityEstimatedPrice
          return text
            ? `${text}${
                price
                  ? ':￥' + (this.isBlur ? '----' : formatNumber(price + this.totalAdditionCommodityActivityPrice))
                  : ''
              }`
            : ''
        } else if (this.hasAdditionCommodity && !this.isBlur) {
          // 如果有加购商品
          // 优先展示套餐价
          let price = 0
          if (this.currentSuiteInfo.id) {
            price = this.currentSuiteInfo.totalPrice + this.totalAdditionCommodityActivityPrice
          } else {
            price =
              (this.skuInfo.commoditySkuDiscount.commodityDiscountPrice ||
                this.skuInfo.commoditySkuBaseInfo.salePrice) + this.totalAdditionCommodityActivityPrice
          }
          return `总价:￥${formatNumber(price)}`
        }
      }
      return ''
    },
    // 埋点按钮内容id
    buyNowButtonId() {
      // 立即秒杀、秒杀未开始、已预约（不考虑这三种情况）
      let allButtonModel = [
        '立即购买',
        '支付定金', // 定金预售
        '全款预定',
        '一键开团',
        '查看推荐商品',
        '立即预约',
        '到货通知',
        '商品暂时缺货',
        '仅作为赠品',
        '商品已下架',
        '领券购买',
        '一分团一键开团',
        '会员先享预热',
        '前往预购商品',
        '立即购买' // 会员-立即购买
      ]

      // 拼团活动单独处理
      if (this.isLottery) {
        return 12
      } else if (this.isGroup) {
        return 4
      } else if (this.isVipFirstBuy && this.commodityVipFirst) {
        // 会员先享购单独处理
        if (this.commodityVipFirst.state == 2) {
          return 13
        } else if (this.btnMainText == '立即购买') {
          return 15
        }
      }
      return allButtonModel.findIndex(item => this.btnMainText?.indexOf(item) > -1) + 1 || 1
    },
    orderedTips() {
      if (this.ordered && this.extCode == 2) return '已成功预约，开始售卖时第一时间通知您！'
      else return '已成功登记，开始售卖时第一时间通知您！'
    },
    // 一站式换新活动
    oneStopAct() {
      // const s = {
      //   oldModelImage: 'https://preyihuadl-oppo-com-test.oss-cn-beijing.aliyuncs.com/product_images/vivo/135.jfif',
      //   memberLevel: 1,
      //   recyclePrice: 3248.0,
      //   recycleReward: 0.0,
      //   fixedReward: null,
      //   memberReward: null,
      //   modelCode: 'VDR12B8H3N',
      //   modelName: null,
      //   quickEvaluatedPriceUrl: null,
      //   accurateEvaluatedPriceUrl:
      //     'https://danghuan-vivo.wanyol.com/static/index.html#/property?productId=&productMaxPrice=&categoryId=2&show_title=0&hide_title=1&showShareBtn=0&showMenuBtn=0&showBrowserLink=0&showCopyLink=0&channelId=1137830&commonImmersive=1&level=1&openId=xXx1rtXWUxqi900OwOaFqnBbnmRVW43WP4vZOHlnz74&modelCode=135&appId=onlinevivo@PC@1#@7wllee57&sign=05d27ef630bcb54914815ef255054865b43b1f443ae490e74428a0e4848d5da1&signType=HS256&timestamp=20231030095420',
      //   supplierId: 1
      // }
      // return s
      return this.skuInfo?.recycleOneStopActivity
    },
    supplierId() {
      return this.oneStopAct?.supplierId || ''
    }
  },
  watch: {
    'commonTrackData.sku_id': {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            // 组件曝光埋点
            this.$track({
              cfrom: '185|001|02|077',
              event_id: '185|001|02|077',
              page_name: this.commonTrackData.page_name,
              buynow_button: this.buyNowButtonId,
              sku_id: this.commonTrackData.sku_id
            })
            this.trackButtonExpose()
          })
        }
      }
    }
  },
  created() {
    // 用于App通知客服消息数量 //宙斯高频错误：ReferenceError: appCustomerServiceNum is not defined
    window && (window.appCustomerServiceNum = this.appCustomerService)
  },
  methods: {
    ...mapActions('detailv3', ['showSkuSelect', 'refresh', 'savePreFocusElByEvent']),
    ...mapMutations('detailv3', ['UPDATE_COLLECTED_DATA']),
    // 上报参数bottom_info 汇总数组批量曝光
    // 底部如果用埋点太复杂，需要到每个元素下面进行判断绑定，不如在这里直接操作DOM
    // 1:客服按钮-有消息红点;2:客服按钮-无消息红点;3:购物车按钮;4:收藏按钮;5:加入购物车按钮;
    // 6:立即购买按钮;7:定金预售;8:全款预定;9:一键开团;10:查看相似商品;11:立即预约;12:到货通知;13:商品暂时缺货;14:仅作为赠品;15:商品已下架;16:领券购买;17:一分团一键开团;18:会员先享预热;19:前往预购商品;20:会员-立即购买;21现货购买
    trackButtonExpose() {
      let infoArray = []
      infoArray.push(this.customerService > 0 ? 1 : 2)
      if (!this.isGroup && !this.isVipFirstBuy && !this.isPreHot) {
        infoArray.push(3)
      }
      if (this.isShowCollect) {
        infoArray.push(4)
      }
      if (!this.isGroup && !this.isPreHot && this.hasShopCart) {
        infoArray.push(5)
      }
      if (!this.isGroup && !this.isPreHot && this.isSpot) {
        infoArray.push(21)
      }
      if (this.buyNowButtonId > 0) {
        infoArray.push(this.buyNowButtonId + 5)
      }
      infoArray.forEach(info => {
        this.fixBarTrack(0, info)
      })
    },
    // type: 0 曝光，1click
    // info: 代表上报参数bottom_info
    fixBarTrack(type, info) {
      let page_name = this.isGroupon ? 2 : 1
      if (type === 1 && this.isShowRemarkPopup) {
        page_name = 9
      }
      this.$track({
        cfrom: type === 0 ? '186|001|02|077' : '186|001|01|077',
        event_id: type === 0 ? '186|001|02|077' : '186|001|01|077',
        bottom_info: info,
        page_name: page_name,
        sku_id: this.commonTrackData.sku_id
      })
    },
    endFun() {
      // 需要整个页面刷新，refresh只能刷新当前sku
      if (this.isVipFirstBuy) {
        window.location.replace(`/wap/product/${this.spuId}?skuId=${this.skuId}&channel=vip`)
      } else {
        this.refresh()
      }
    },
    goHome() {
      location.href = config.path.shopUrl + '/index.html'
    },
    /**
     * 收藏、取消收藏
     */
    toggleCollected() {
      this.clickTrack(4)
      this.fixBarTrack(1, 4)
      if (this.isDoing) {
        return
      }
      this.isDoing = true
      // 延时恢复标志位
      let timeId = setTimeout(() => {
        this.isDoing = false
      }, 2000)
      let param = {
        skuId: this.skuId,
        // 0 普通商品 4 服务商品
        goodsType: this.isServiceGoods ? 4 : 0
      }
      let _this = this
      let skuids = [].concat(this.collectedSkuIds)
      collectionProduct(!this.collected, param)
        .then(data => {
          if (_this.collected) {
            // 取消收藏
            skuids.splice(_this.collectedSkuIds.indexOf(_this.skuId), 1)
            _this.isClicked = false
            _this.toastSuccess(_this.collected)
          } else {
            skuids.push(_this.skuId)
            _this.isClicked = true
            let message = shareRewardTip('收藏', data)
            if (message) {
              _this.$toast({
                type: 'html',
                message: message
              })
            } else {
              _this.toastSuccess(_this.collected)
            }
            // push召回
            _this.$nextTick(() => {
              _this.notifyCheck()
            })
          }
          _this['UPDATE_COLLECTED_DATA'](skuids)
          _this.isDoing = false
          clearTimeout(timeId)
        })
        .catch(e => {
          e.msg && this.$toast(e.msg)
          _this.isDoing = false
          clearTimeout(timeId)
        })
    },
    /**
     * 收藏、取消收藏成功提示
     */
    toastSuccess(collected) {
      let txt = collected ? '取消成功' : '收藏成功'
      this.$toast({
        type: 'success',
        message: txt
      })
    },
    /**
     * push 召回，如果收藏的是到货通知的商品，则进行push召回检查
     */
    notifyCheck() {
      // 到货通知的商品启用push召回
      if (this.extCode == 3) {
        app.checkNotifyAuth({
          id: 2,
          title: '开启消息通知',
          content: '开启消息通知，商品到货早知道！'
        })
      }
    },
    // 获取客服消息 0：无消息；1：有消息
    appCustomerService(val) {
      this.customerService = Number(val)
    },
    // 联系客服
    toConnect() {
      this.clickTrack(this.customerService > 0 ? 1 : 2)
      this.fixBarTrack(1, this.customerService > 0 ? 1 : 2)

      let url = window.location.href
      window.location.href =
        'https://kefu.vivo.com.cn/robot-vivo/mobileChat.html?f=mall&forVivoSpace=share.mp.qq.com/cgi/share.php&commodityType=' +
        this.goodsType
         +
        '&url=' +
        encodeURIComponent(url)
    },
    // 去购物车
    jumpTo() {
      this.clickTrack(3)
      this.fixBarTrack(1, 3)
      app.openNewWebview({
        url: config.path.shopUrl + '/shoppingcart'
      })
    },
    // 加入购物车
    addCart(e) {
      this.fixBarTrack(1, 5)
      this.savePreFocusElByEvent(e)
      if (this.isService) {
        this.$emit('submit', { isAdd: true })
      } else {
        this.showSkuSelect({
          isShow: true,
          params: {
            source: 2
          }
        })
      }
    },
    // 确认，如果没有弹层，则直接进行结算校验，否则调起选择弹层
    confirm(e) {
      // 点击埋点
      this.submitClickTrack()
      this.savePreFocusElByEvent(e)
      if (this.buyNowButtonId > 0) {
        this.fixBarTrack(1, this.buyNowButtonId + 5)
      }
      // 会员先享购无库存
      if (this.vipFirstBuyDisable) {
        vipFirstBuyPopup({
          vipBuyStatus: 2,
          skuInfo: this.skuInfo,
          isTrackClick: true
        })
        return false
      }
      // 仅做赠品，不做任何处理
      if (this.isGray) return false
      // 预热倒计时，不做任何处理
      if (this.isPreHot) {
        this.showSkuSelect({
          isShow: true
        })
        return false
      }
      // 查看推荐商品，跳转到推荐模块
      if (this.isSeeOther) {
        return this.$emit('seeOther')
      }
      // 立即预约或到货通知，调起预约弹窗
      if (this.extCode == 2 || this.extCode == 3) {
        return this.$emit('showAppointment')
      }
      if (this.isVipFirstBuy && !this.commodityVipFirst?.vipAllowed) {
        let spuId = this.spuInfo.commoditySpu.id
        let skuId = this.skuInfo.commoditySkuBaseInfo.skuId
        window.location.href = `${this.shopUrl}/product/${spuId}?skuId=${skuId}`
        return
      }
      if (this.isService) {
        this.$emit('submit')
      } else {
        this.showSkuSelect({
          isShow: true
        })
      }
    },
    // 现货购买（定金预售）
    spotBuy(e) {
      this.fixBarTrack(1, 21)
      this.savePreFocusElByEvent(e)
      this.showSkuSelect({
        isShow: true,
        params: {
          isSpot: this.isSpot * 1,
          source: 13
        }
      })
    },
    // 单独购买（拼团）
    ordinaryBuy(e) {
      this.savePreFocusElByEvent(e)
      this.showSkuSelect({
        isShow: true,
        params: {
          source: 8
        }
      })
    },
    // 一键开团
    group(e) {
      // 如果拼团，且只有一个sku，直接进行开团提交，不用打开弹层
      if (this.isSimpleGroup) {
        this.$emit('submit')
      } else {
        this.savePreFocusElByEvent(e)
        this.showSkuSelect({
          isShow: true,
          params: {
            source: 6
          }
        })
      }
      this.submitClickTrack()
      this.fixBarTrack(1, this.buyNowButtonId + 5)
    },
    submit(data) {
      this.$emit('submit', data)
    },
    // 点击埋点
    clickTrack(bottom_info) {
      let page_name = this.commonTrackData.page_name
      if (this.isShowRemarkPopup) {
        page_name = 9
      }
      this.$track({
        cfrom: '186|001|01|077',
        event_id: '186|001|01|077',
        page_name: page_name,
        bottom_info: bottom_info,
        sku_id: this.commonTrackData.sku_id
      })
    },
    submitClickTrack() {
      this.$track({
        cfrom: '185|001|01|077',
        event_id: '185|001|01|077',
        page_name: this.commonTrackData.page_name,
        buynow_button: this.buyNowButtonId,
        sku_id: this.commonTrackData.sku_id
      })
    },
    goUpgrade() {
      // 埋点上报
      this.$track({
        cfrom: '081|069|01|077',
        event_id: '081|069|01|077'
      })
      let url = this.commodityVipFirst?.upLevelUrl
      url && (window.location.href = url)
    },
    goToRenew() {
      this.$emit('goToRenew', { trackFrom: 2 }) // 商详页悬浮条
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-1 {
  .action .links .link_item .icon .badge {
    line-height: 48px;
  }
}
.vivo-fontscale-4 {
  .action .links .link_item .icon .badge {
    min-width: 48px;
    height: 48px;
  }
}
.vivo-fontscale-5 {
  .action .links .link_item {
    width: 120px;
    .icon .badge {
      min-width: 54px;
      height: 54px;
      top: -12px;
    }
  }
}
</style>
